export function setEncryptPassword(password) {
  var CryptoJS = require("crypto-js");
  const SECRET_KEY_PASSWORD = `CaWgs4A7gBqhjFIQVSOuTxWkxFEGSx`;
  // const SECRET_KEY_PASSWORD =
  //   window._env_?.REACT_APP_SECRET_KEY_PASSWORD ||
  //   process.env.REACT_APP_SECRET_KEY_PASSWORD;

  const newPassword = CryptoJS.AES.encrypt(
    JSON.stringify(password),
    `${SECRET_KEY_PASSWORD}`,
  ).toString();
  return newPassword;
}
